import { render, staticRenderFns } from "./BlockedIPs.vue?vue&type=template&id=979408ec&scoped=true&"
import script from "./BlockedIPs.vue?vue&type=script&lang=js&"
export * from "./BlockedIPs.vue?vue&type=script&lang=js&"
import style0 from "./BlockedIPs.vue?vue&type=style&index=0&id=979408ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979408ec",
  null
  
)

export default component.exports